import { act } from "react-dom/cjs/react-dom-test-utils.production.min"
import {
	SEARCH_TYPING,
	SEARCH_SUCCESS,
	SEARCH_ERROR,
	SEARCH_UPDATE_DOCUMENT_PRIORITY,
	SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	SEARCH_ADD_CONCEPT_TARGET_TERMS,
	SEARCH_UPDATE_DOCUMENT_DATE,
	SEARCH_SET_SOURCE_FILTER,
	SEARCH_DOCS_DATA_SUCCESS,
	SEARCH_RESULTS_CLEAR,
	UPDATE_FILE_LIST_COMMENT,
	UPDATE_FILE_LIST_TAG,
	UPDATE_SEARCH_METADATA,
	GET_FILE_LIST_REQUEST,
	GET_FILE_LIST_REQUEST_SUCCESS,
	GET_FILE_LIST_REQUEST_FAILED,
	GET_FILE_LIST_REQUEST_FAILED_CLEAR,
	UPDATE_META_DATA_COMMENT_COUNT,
	UPDATE_FILE_TAG_SUCCESS,
	UPDATE_FILE_TAG,
	UPDATE_FILE_TAG_FAILED,
	UPDATE_FILE_TAG_RESET,
} from "../types"

//cada reducer tiene su propio state
const initialState = {
	searchResults: {
		count: 0,
		data: [],
		id_search: {},
	},
	error: null,
	loading: false,
	concept_target_terms: [],
	sourceFilter: {
		doc: true,
		xls: true,
		ppt: true,
		pdf: true,
		txt: true,
		email: true,
		fromDate: "",
		toDate: "",
	},
	searchReducer: [],
	searchDocsData: [],
	searchDocViewResults: {
		count: 0,
		data: [],
		id_search: {},
	},
	isDocsViewLoading: false,
	docsViewError: null,
	isApplyTagLoading: false,
	isApplyTagSuccess: false,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case SEARCH_SET_SOURCE_FILTER:
			return { ...state, sourceFilter: action.payload }
		case SEARCH_ADD_CONCEPT_TARGET_TERMS:
			//var auxTerms= state.concept_target_terms.concat(action.payload);
			return {
				...state,
				//concept_target_terms: auxTerms
				concept_target_terms: action.payload.concat(state.concept_target_terms),
			}
		case SEARCH_CLEAR_CONCEPT_TARGET_TERMS:
			return {
				...state,
				concept_target_terms: action.payload,
			}
		case SEARCH_UPDATE_DOCUMENT_PRIORITY:
			try {
				let index = state.searchResults.data.findIndex((data) => data.id === action.payload.id)
				let aux_concept_docs = state.searchResults
				aux_concept_docs.data[index]["tags"] = action.payload.priority
				return { ...state, searchResults: aux_concept_docs }
			} catch (error) {
				return { ...state }
			}
		case SEARCH_UPDATE_DOCUMENT_DATE:
			try {
				let index = state.searchResults.data.findIndex((data) => data.id === action.payload.id)
				let aux_concept_docs = state.searchResults
				aux_concept_docs.data[index]["tagged_date"] = action.payload.date

				return { ...state, searchResults: aux_concept_docs }
			} catch (error) {
				return { ...state }
			}

		case UPDATE_FILE_LIST_COMMENT:
			let index = state.searchDocViewResults.data.findIndex((data) => data.id === action.payload.docId)
			let aux_concept_docs = { ...state.searchDocViewResults }
			if (index >= 0) aux_concept_docs.data[index]["comments"] = action.payload.data
			return {
				...state,
				searchDocViewResults: aux_concept_docs,
			}
		case UPDATE_FILE_LIST_TAG:
			let iNdex = state.searchDocViewResults.data.findIndex((data) => data.id === action.payload.docId)
			let filedocs = { ...state.searchDocViewResults }
			if (iNdex >= 0) filedocs.data[iNdex]["tags"] = action.payload.data
			return {
				...state,
				searchDocViewResults: filedocs,
			}
		case UPDATE_META_DATA_COMMENT_COUNT:
			let idex = state.searchResults.data.findIndex((data) => data.id === action.payload.docId)
			let docs = { ...state.searchResults }
			if (idex >= 0) docs.data[idex]["comments_count"] = action.payload.count
			return {
				...state,
				searchResults: docs,
			}

		case SEARCH_TYPING:
			return {
				...state,
				loading: action.payload,
			}
		case SEARCH_SUCCESS:
			return {
				...state,
				loading: false,
				searchResults: {
					id_search: action.payload.conceptData.id,
					count: action.payload.conceptData.data.count,
					data: action.payload.responseDocsData,
				},
			}
		case UPDATE_SEARCH_METADATA:
			const payload = action.payload
			const currentData = { ...state.searchResults }
			const iIndex = Array.isArray(currentData.data) ? currentData.data.findIndex((data) => data.id === payload.id) : -1 //find the id
			if (iIndex !== -1) {
				let updateRecord = currentData.data[iIndex] //get the object
				updateRecord = { ...updateRecord, ...payload.data } //update the object
				currentData.data[iIndex] = updateRecord //assign bakc to list
			}

			return {
				...state,
				searchResults: currentData,
			}

		case SEARCH_RESULTS_CLEAR:
			return {
				...initialState,
				sourceFilter: { ...initialState.sourceFilter, ...state.sourceFilter },
			}
		case SEARCH_ERROR:
			return {
				...state,
				loading: false,

				error: action.payload,
			}

		case SEARCH_DOCS_DATA_SUCCESS:
			return {
				...state,
				searchDocsData: action.payload,
			}

		case GET_FILE_LIST_REQUEST:
			return {
				...state,
				loading: true,
				searchDocViewResults: {
					count: 0,
					data: [],
					id_search: {},
				},
			}
		case GET_FILE_LIST_REQUEST_SUCCESS:
			return {
				...state,
				loading: false,
				searchDocViewResults: action.payload,
			}
		case GET_FILE_LIST_REQUEST_FAILED:
			return {
				...state,
				loading: false,
				docsViewError: action.payload,
			}
		case GET_FILE_LIST_REQUEST_FAILED_CLEAR:
			return {
				...state,
				loading: false,
				searchDocViewResults: {
					count: 0,
					data: [],
					id_search: {},
				},
			}
		case UPDATE_FILE_TAG:
			return {
				...state,
				isApplyTagLoading: true,
				isApplyTagSuccess: false,
			}
		case UPDATE_FILE_TAG_SUCCESS:
			let matchedDocIndex = state.searchDocViewResults.data.findIndex((data) => data.id === action.payload.document_id)
			let allDocs = { ...state.searchDocViewResults }
			if (matchedDocIndex >= 0) allDocs.data[matchedDocIndex]["tags"] = action.payload.tag_id
			return {
				...state,
				searchDocViewResults: allDocs,
				isApplyTagLoading: false,
				isApplyTagSuccess: true,
			}
		case UPDATE_FILE_TAG_FAILED:
			return {
				...state,
				isApplyTagLoading: false,
				isApplyTagSuccess: false,
			}
		case UPDATE_FILE_TAG_RESET:
			return {
				...state,
				isApplyTagLoading: false,
				isApplyTagSuccess: false,
			}

		default:
			return state
	}
}
